import { createTheme } from '@mui/material/styles';

const primaryColor = '#f59723';
const lightPrimaryBg = '#fff4e4'
const secondaryColor = '#0288d1';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: primaryColor,
      light: '#ffab40',
      dark: '#c8761b',
      contrastText: '#fff',
    },
    secondary: {
      main: '#0288d1',
      light: '#4fc3f7',
      dark: '#015f92',
      contrastText: '#fff',
    },
    background: {
      default: '#f5f5f5',
      paper: '#fff',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    body1: {
      color: '#333',
      fontSize: '1rem',
      lineHeight: 1.5,
    },
    h1: {
      fontSize: '2.5rem',
      fontWeight: 500,
      color: '#222',
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 500,
      color: '#222',
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          margin: 0,
          // backgroundColor: '#fff4e4',
        },
      },
    },
    // MuiLink: {
    //   styleOverrides: {
    //     root: {
    //       color: primaryColor,
    //       textDecoration: 'none',
    //       '&:hover': {
    //         color: '#c8761b',
    //         textDecoration: 'underline',
    //         cursor: 'pointer',
    //       },
    //       '&:focus': {
    //         outline: '2px solidprimaryColor,
    //         outlineOffset: '2px',
    //       },
    //     },
    //   },
    // },
    MuiLink: {
      styleOverrides: {
        root: {
          color: primaryColor,
          textDecoration: 'none',
          '&:hover': {
            color: primaryColor,
            textDecoration: 'underline',
            cursor: 'pointer',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          margin: '4px',
          // borderRadius: '12px',
          padding: '8px 16px',
        },
      },
      variants: [
        {
          props: { variant: 'outlined' },
          style: {
            color: primaryColor,
            borderColor: primaryColor,
            '&:hover': {
              backgroundColor: 'rgba(245, 151, 35, 0.1)',
              borderColor: '#c8761b',
            },
          },
        },
        {
          props: { variant: 'contained' },
          style: {
            backgroundColor: primaryColor,
            color: '#fff',
            '&:hover': {
              backgroundColor: '#c8761b',
            },
          },
        },
      ],
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          // borderRadius: '12px',
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              // 
            },
            '&:hover fieldset': {
              borderColor: primaryColor,
            },
            '&.Mui-focused fieldset': {
              borderColor: primaryColor,
            },
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          // borderRadius: '12px', // Define o border-radius desejado
        },
      },
      variants: [
        {
          props: { variant: 'transparent' },
          style: {
            backgroundColor: 'transparent',
            // '&:hover': { // comentado
            //   backgroundColor: 'darkred',
            // },
          },
        },
      ],
    },
  },
});

export default theme;